<template>
  <Viewer ref="viewer" :value="content || emptyText" />
</template>

<script>
import { Viewer } from '@toast-ui/vue-editor'

export default {
  name: 'markdown-view',
  components: {
    Viewer
  },
  props: {
    emptyText: {
      type: String,
      default: '请输入文字'
    },
    content: {
      type: String,
      default: null
    }
  }
}
</script>
